import { Helmet } from "react-helmet-async";
import { Wrench, Heart } from "lucide-react";

type MaintenancePageProps = {
  message?: string | null;
};

const MaintenancePage = ({ message }: MaintenancePageProps) => {
  return (
    <>
      <Helmet>
        <title>Pracujemy nad ulepszeniami - GdzieSchronisko.pl</title>
        <meta name="robots" content="noindex" />
        <meta
          name="description"
          content="Trwają prace techniczne. Wracamy z mapą schronisk i ich potrzebami za chwilę."
        />
      </Helmet>

      <main className="min-h-[100dvh] flex items-center justify-center bg-gradient-to-br from-primary/5 via-background to-primary/10 px-4 py-10">
        <div className="max-w-md w-full bg-card border rounded-3xl shadow-xl p-6 sm:p-10 text-center space-y-5">
          <div className="mx-auto flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <Wrench className="h-8 w-8 sm:h-10 sm:w-10" strokeWidth={1.8} />
          </div>

          <div className="space-y-2">
            <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">
              Pracujemy nad ulepszeniami
            </h1>
            <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
              Trwają drobne prace techniczne. Wracamy za chwilę z aktualną mapą schronisk i ich potrzebami.
            </p>
          </div>

          {message && message.trim().length > 0 && (
            <div className="rounded-2xl border border-primary/20 bg-primary/5 p-3 text-left">
              <p className="text-xs sm:text-sm text-foreground/90 whitespace-pre-wrap leading-relaxed">
                {message}
              </p>
            </div>
          )}

          <div className="pt-2 flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
            <Heart className="h-3.5 w-3.5 text-primary" />
            <span>Zespół GdzieSchronisko.pl</span>
          </div>
        </div>
      </main>
    </>
  );
};

export default MaintenancePage;
